import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogContent, MatDialogActions, MatDialogClose, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalVariables } from '../../constants/global-constants';
type ConfirmationDialogData = {
  title?: string;
  content?: string;
  okayBtnText?: string;
  cancelBtnText?: string;
  warn?: boolean;
};
@Component({
  selector: 'app-user-feedback-confirmation',
  standalone: true,
  imports: [
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatDialogClose],
  templateUrl: './user-feedback-confirmation.component.html',
  styleUrl: './user-feedback-confirmation.component.scss'
})
export class UserFeedbackConfirmationComponent {
 title = 'Confirmation';
  content = 'Are you sure you want to continue?';
  okayBtnText = 'Continue';
  cancelBtnText = 'Cancel';
  warn = false;

  constructor(
    private dialogRef: MatDialogRef<UserFeedbackConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData | null
  ) {
    if (data) {
      this.title = data.title ?? this.title;
      this.content = data.content ?? this.content;
      this.okayBtnText = data.okayBtnText ?? this.okayBtnText;
      this.cancelBtnText = data.cancelBtnText ?? this.cancelBtnText;
      this.warn = data.warn ?? this.warn;
    }
  }

  continue() {
    this.dialogRef.close({ data: GlobalVariables.CONFIRMED });
  }
}
